module.exports = __webpack_public_path__ + "img/logo-locatelli.d21fe1bf.svg";